import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs/Observable";

import { catchError, map, tap } from "rxjs/operators";

import { CommonService } from "./common.service";

import { environment } from "../../environments/environment";

@Injectable()
export class FileUploadService {
  constructor(private http: HttpClient, private commonService: CommonService) {}

  private httpOptions = this.commonService.httpOptions;

  /**
   * 再検査通知一覧の取得
   * @param {event} any ファイル選択イベント
   * @returns
   */
  getFileUploadList(param: any) {
    this.commonService.loadingStart();
    return this.http
      .get(
        environment.apiUrl +
          "/api/fileupload/file_upload_list/" +
          param.t_person_id,
        this.httpOptions
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("file_upload_list", []))
      );
  }

  /**
   * 再検査通知ファイルのダウンロード
   * @param {param} any {t_saiken_file_id : 【再検査ファイルID】}
   * @returns
   */
  downloadSaikenFile(param: any) {
    var request = ""; /*GETリクエスト*/
    for (var key in param) {
      if (request === "") {
        request += "?";
      } else {
        request += "&";
      }
      request += key + "=" + param[key];
    }
    request =
      environment.apiUrl + "/api/fileupload/download_saiken_file" + request;
    return this.http
      .get(request, {
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        catchError(this.commonService.handleError("download_saiken_file", []))
      );
  }

  /**
   * 再検査通知ファイルのダウンロード
   * @param {param} any {t_saiken_upload_file_id : 【アップロードファイルID】}
   * @returns
   */
  downloadSaikenUploadFile(param: any) {
    var request = ""; /*GETリクエスト*/
    for (var key in param) {
      if (request === "") {
        request += "?";
      } else {
        request += "&";
      }
      request += key + "=" + param[key];
    }
    request =
      environment.apiUrl +
      "/api/fileupload/download_saiken_upload_file" +
      request;
    return this.http
      .get(request, {
        observe: "response",
        responseType: "blob",
      })
      .pipe(
        catchError(
          this.commonService.handleError("download_saiken_upload_file", [])
        )
      );
  }

  /**
   * 再検査通知ファイルのダウンロード
   * @param {param} any フォームデータ
   * @returns
   */
  uploadSaikenFile(param: any) {
    this.commonService.loadingStart();
    return this.http
      .post(environment.apiUrl + "/api/fileupload/upload_saiken_file", param)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("upload_saiken_file", []))
      );
  }

  /**
   * 再検査対象取込
   * @param {param} FormData フォームデータ
   * @returns
   */
  importSaiken(file_data: FormData) {
    //    this.commonService.loadingStart();
    return this.http
      .post(environment.apiUrl + "/api/fileupload/import_saiken", file_data)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("import_person", []))
      );
  }

  /**
   * 再検査対象取込
   * @param {t_saiken_file_id} number 再検査ファイル
   * @returns
   */
  getSaikenFileBinary(t_saiken_file_id) {
    //    this.commonService.loadingStart();
    return this.http
      .get(
        environment.apiUrl +
          "/api/fileupload/saiken_file_to_binary/" +
          t_saiken_file_id,
        this.httpOptions
      )
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("saiken_file_to_binary", []))
      );
  }

  // ファイルアップロード機能（管理者）マイナビ202607 start
  /**
   * 関連ファイル取込
   * @param FormData フォームデータ
   * @returns
   */
  importKanren(file_data: FormData) {
    return this.http
      .post(environment.apiUrl + "/api/fileupload/import_kanren", file_data)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("import_kanren", []))
      );
  }

  /**
   * 関連ファイル取込（差し替え）
   * @param FormData フォームデータ
   * @returns
   */
  importKanrenReplace(file_data: FormData) {
    return this.http
      .post(environment.apiUrl + "/api/fileupload/import_kanren_replace", file_data)
      .pipe(
        tap((Response) => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError("import_kanren_replace", []))
      );
  }
  // ファイルアップロード機能（管理者）マイナビ202607 end
}



// WEBPACK FOOTER //
// ./src/app/service/fileupload.service.ts